/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'update-trans': {
    width: 9,
    height: 12,
    viewBox: '0 0 9 12',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M2.108 6.624H6.7M2.108 4.401h2.29M.5 1.114h7.856v9.982L6.961 9.824l-1.223 1.272-1.31-1.272-1.481 1.272-1.085-1.272L.5 11.096z"/></g>'
  }
})
